import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DEBUG_INFO_ENABLED } from './app.constants';
import { ERROR_ROUTES } from './layouts';
import { routes } from './app.route';
import { LOGIN_ROUTES } from './login/login.route';

const ROUTES = [
    ...routes,
    ...ERROR_ROUTES,
    ...LOGIN_ROUTES,
];

@NgModule({
    imports: [
        RouterModule.forRoot(ROUTES, { useHash: true, enableTracing: DEBUG_INFO_ENABLED })
    ],
    exports: [
        RouterModule
    ]
})
export class BmsjHipsterAppRoutingModule {
}
